<template>
  <div>
    <el-form-item label="购销计划" required>
      <el-select class="rule" v-model="contract" placeholder="请选择购销计划" @change="selectContract">
        <el-option
          v-for="(item, index) in contractList"
          :key="index"
          :label="item.dictSubCode"
          :value="item.dictSubCode" />
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapState } = createNamespacedHelpers('framework')

export default {
  name: 'contract',
  props: {
    contractCode: { // 发布报价的时候，从父组件带过来已经选好的合约
      type: String,
      default: ''
    },
    nowTime: { // 服务器当前时间
      type: String,
      default: ''
    }
  },
  data () {
    return {
      contract: '', // 合约
      parseNowDate: '', // 当前时间戳转化后的日期串,如‘190522’
      contractList: [], // 最后定价合约
      contractDate: '' // 合约对应的日期
    }
  },
  computed: {
    ...mapState({
      userInfo: 'userInfo'
    })
  },
  watch: {
    contract (val) {
      this.$emit('input', val)
    },
    contractCode (val) {
      this.contract = val
      this.selectContract(val)
    }
  },
  mounted () {
    this.getContract() // 获取合约
  },
  methods: {
    // 获取最后定价合约
    getContract () {
      const url = this.$API.releaseQuotation.basedatadictsub
      const param = {
        currentNo: 1,
        dictCode: 'goodsInvalidDate',
        dictStatus: '1',
        pageSize: 50
      }
      this.$http.post(url, param).then((res) => {
        const dateObj = this.$utils.formatTimeObj(Date.parse(new Date()))
        this.parseNowDate = dateObj.y + dateObj.m + dateObj.d // 获得当前时间戳转化后的日期串,如‘190522’
        const sortList = this.sortArr(res.data.rows) // 按照日期排序的合约数组
        const plan = this.userInfo.account.length < 5 ? 'YS' : 'GS' // 根据账号长度判断合约类型
        this.contractList = sortList.filter((item) => {
          return ((Number(this.parseNowDate) + 1) <= Number(item.dictSubValue)) && item.dictSubCode.includes(plan)
        })
        // 将合约数组的首个合约传给父组件，用于判断是跨月还是当月
        if (this.contractList.length > 0) {
          this.$emit('getFirstContract', this.contractList[0].dictSubCode)
        }
      })
    },
    // 将合约数组按照合约日期从小到大的顺序排序
    sortArr (arr) {
      let list = arr
      const len = list.length
      let minIndex, temp
      for (let i = 0; i < len - 1; i++) {
        minIndex = i
        for (let j = i + 1; j < len; j++) {
          // 比较两个合约的日期数字的的大小
          if (Number(list[j].dictSubValue) < Number(list[minIndex].dictSubValue)) {
            minIndex = j
          }
        }
        temp = list[i]
        list[i] = list[minIndex]
        list[minIndex] = temp
      }
      return list
    },
    // 选择购销计划
    selectContract (val) {
      // 将选择的购销计划对应项找出来
      const contract = this.contractList.filter((item) => {
        return item.dictSubCode === val
      })
      if (contract.length !== 0) {
        this.contractDate = contract[0].dictSubValue // 得到对应的日期
        this.$emit('returnContract', this.contract, this.contractDate)
      }
    },
    // 重置数据
    reset () {
      this.contract = ''
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
